(function () {
  const KEY = 'url_stack';
  const MAX = 20;

  function getStack() {
    try {
      return JSON.parse(sessionStorage.getItem(KEY) || '[]');
    } catch {
      return [];
    }
  }
  function setStack(stack) {
    sessionStorage.setItem(KEY, JSON.stringify(stack.slice(-MAX)));
  }

  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a) return;

    const href = a.getAttribute('href') || '';
    if (!href.includes('/products/')) return;

    // Build return URL for current page (include section anchor if present)
    let current = location.pathname + location.search;

    const section = e.target.closest('[data-return-anchor]');
    if (section) {
      const anchor = section.getAttribute('data-return-anchor');
      if (anchor) current += '#' + anchor;
    } else if (location.hash) {
      current += location.hash;
    }

    const stack = getStack();
    if (stack[stack.length - 1] !== current) stack.push(current);
    setStack(stack);
  });

  window.__peekReturnUrl = () => {
    const stack = getStack();
    return stack[stack.length - 1] || null;
  };

  window.__popReturnUrl = () => {
    const stack = getStack();
    const url = stack.pop();
    setStack(stack);
    return url || null;
  };
})();
